import { type ContextMenuList } from '../types/context-menu-list.type';
import { hideDimensionMenuItem } from '../menu-item/hide-dimension-menu-item';
import { rotateDimensionMenuItem } from '../menu-item/rotate-dimension-menu-item';

export const dimensionMenuList: Array<ContextMenuList> = [
	hideDimensionMenuItem(),
	rotateDimensionMenuItem()
];
